module.exports = " <div id=color _v-395d0536=\"\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-395d0536!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BraColor.vue
// module id = 11
// module chunks = 1